import { isString } from 'lodash';
import { formatText, getPageUrl } from '@/utils/helpers';

export const getBreadcrumbComponent = ({ page }: any) => {
  const breadCrumbCmp = page.getComponent('main', 'breadcrumb') || undefined;
  return breadCrumbCmp;
};

export const getBreadcrumbData = ({ breadCrumbCmp: component }: any) => {
  const models = component?.getModels() || undefined;
  const { breadcrumbData } = models || {};
  return breadcrumbData;
};

export const getBreadcrumbSecondLastLink = ({ breadcrumbData: data }: any) => {
  const { items } = data || {};
  const length = items ? items.length : 0;
  const index = length - 2;
  const link = length >= 2 ? items[index] : undefined;
  return link;
};

export const getBackLink = ({ breadcrumbLink, backLabel, page }: any): LinkType => {
  const { title, link } = breadcrumbLink || {};
  const label = backLabel && formatText(backLabel, [title]);
  const url = isString(link) ? link : link?.href;
  const href = getPageUrl({ url, page });

  return {
    displayText: label,
    href,
  };
};
